import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safe-guard-info',
  templateUrl: './safe-guard-info.component.html',
  styleUrls: ['./safe-guard-info.component.css']
})
export class SafeGuardInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
